import { Injectable } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from 'src/state/app.state';
import { enableConfigAPI, enablePage, loadQueryParameters } from 'src/state/app-meta/app-meta.actions';
import { queryParam } from '../models/config.interface';


@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {
  private _user: queryParam = { value: undefined };
  private _id: queryParam = { value: undefined };
  private _project: queryParam = { value: undefined };
  private _key: queryParam = { value: undefined };
  private _lng: queryParam = { value: undefined };
  private _country: queryParam = { value: undefined };
  private _RID: queryParam = { value: undefined };

  constructor(
    private route: ActivatedRoute,
    private store: Store<AppState>
  ) {
    this.route.queryParams.subscribe((params) => {
      this.getParamFromRoute(this._user, params, 'user');
      this.getParamFromRoute(this._id, params, 'id');
      this.getParamFromRoute(this._project, params, 'project');
      this.getParamFromRoute(this._key, params, 'key');
      this.getParamFromRoute(this._lng, params, 'lng');
      this.getParamFromRoute(this._country, params, 'country');
      this.getParamFromRoute(this._RID, params, 'RID');
      console.log(`>>> SubscriptionService; Language set from route query params: ${JSON.stringify(this._lng)}`);
      this.checkAllParams();
    });
  }

  /**
  * Get the specified query parameter from route and update corresponding paramVar
  */
  private getParamFromRoute(paramVar: any, params: Params, paramName: string): void {
    if (params && Object.keys(params).includes(paramName)) {
      paramVar.value = params[paramName];
    }
  }

  /**
  * Check if all query parameters are present and update the store accordingly
  */
  private checkAllParams(): void {
    if (
      this._user.value && this._user.value.length > 0 &&
      this._id.value && this._id.value.length > 0 &&
      this._project.value && this._project.value.length > 0 &&
      this._key.value && this._key.value.length > 0 &&
      this._lng.value && this._lng.value.length > 0 &&
      this._country.value && this._country.value.length > 0 &&
      this._RID.value && this._RID.value.length > 0
    ) {
      this.store.dispatch(loadQueryParameters({
        user: this._user,
        id: this._id,
        project: this._project,
        key: this._key,
        lng: this._lng,
        country: this._country,
        RID: this._RID
      }));
      
      this.store.dispatch(enableConfigAPI({
        enableConfigAPI: true,
      }));

      this.store.dispatch(enablePage({
        disablePage: true,
        stopLoadingSpinner: false,
        noConfigData: false
      }));
    } else {
      this.store.dispatch(enablePage({
        disablePage: true,
        stopLoadingSpinner: true,
        noConfigData: false
      }));
    }
  }
}